var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"small":_vm.$vuetify.breakpoint.mobile},on:{"click":_vm.goBack}},[_vm._v("mdi-arrow-left")])
}
var staticRenderFns = []

export { render, staticRenderFns }